import { render, staticRenderFns } from "./bulma_fieldset.vue?vue&type=template&id=22d9c854&scoped=true&lang=html"
import script from "./bulma_fieldset.vue?vue&type=script&lang=js"
export * from "./bulma_fieldset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9c854",
  null
  
)

export default component.exports